import React, { useState, useEffect } from "react";
import AsyncSelect from "react-select/async";
import { makeStyles, Typography } from "@material-ui/core";
import { searchUsers, getUsers } from "../../../../service/endpoint-manager";
import { useSnackbar } from "notistack";
import debounce from "lodash.debounce";
import Loading from "../Loading";
import FormError from "../../../FormError";
import { ErrorMessage } from "formik";
const useStyles = makeStyles(() => ({
  error: {
    fontSize: "9px",
    color: "red",
    position: "absolute",
  },
}));

const customStyles = {
  control: (base, state) => ({
    ...base,
    borderRadius: "4px",
    minHeight: "45px",
    height: "45px",
    cursor: "pointer",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {
      // Overwrittes the different states of border
      borderColor: state.isFocused ? "black" : "black",
    },
  }),
  placeholder: (provided, state) => ({
    ...provided,
    fontSize: "13px",
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: "45px",
    padding: "0 6px",
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: "45px",
  }),
  IndicatorSeparator: () => ({
    display: "none",
  }),
  menu: (base) => ({
    ...base,
    // override border radius to match the box
    borderRadius: 0,
    // kill the gap
    marginTop: 0,
    minWidth: "100%",
  }),
  menuList: (base) => ({
    ...base,
    // kill the white space on first and last option
    padding: 0,
  }),
};

const UserSelectField = ({
  userId,
  title,
  initiallySelectedUser,
  handleUserChange,
  name,
  required,
  optionLabel,
  optionValue,
  isFormik,
}) => {
  const classes = useStyles();

  const _loadSuggestions = async (query, callback) => {
    if (query.length > 0) {
      setSuggestionsLoading(true);
      const result = await searchUsers(query);
      if (result?.status === 200) {
        callback(result?.data?.body?.Items);
        // TODO: filter userList that is already in users state
      } else {
        enqueueSnackbar(`${result?.response?.data?.message}`, {
          variant: "error",
        });
      }
      setSuggestionsLoading(false);
    }
  };

  const loadSuggestions = debounce(_loadSuggestions, 300);

  const [suggestionsLoading, setSuggestionsLoading] = useState(false); //suggestions for autocomplete
  const [userList, setUserList] = useState([]);
  const [loading, setLoading] = useState(true);

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const getInitialOptionsForUserSearch = async () => {
      const result = await getUsers(10);

      if (initiallySelectedUser) {
        const check = userList.find(
          (option) => option?.user_id === initiallySelectedUser?.user_id
        );

        if (check) {
          setUserList([...result?.data?.body?.Items, initiallySelectedUser]);
        }
      } else {
        setUserList(result?.data?.body?.Items);
      }
    };

    getInitialOptionsForUserSearch();
  }, []);

  useEffect(() => {
    setLoading(false);
  }, [userList > 0]);

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <div style={{ marginTop: "10px", marginBottom: "10px" }}>
        {title ? (
          <Typography
            style={{
              alignItems: "center",
              position: "absolute",
              fontSize: ".8rem",
            }}
          >
            {title}
            {required && (
              <span
                style={{
                  color: "red",
                  fontWeight: 500,
                  fontSize: "15px",
                }}
              >
                *
              </span>
            )}
          </Typography>
        ) : (
          <></>
        )}

        {userList && (
          <AsyncSelect
            placeholder="Observer"
            menuPlacement="auto"
            menuPosition="fixed"
            styles={customStyles}
            getOptionLabel={(option) => (optionLabel ? option?.userName : null)}
            getOptionValue={(option) => (optionValue ? option?.user_id : null)}
            defaultOptions={[{ userName: "All", user_id: "All" }, ...userList]}
            value={
              userList
                ? userList.find((option) => option?.user_id === userId)
                : "All"
            }
            disableUnderline
            name={name}
            loadOptions={loadSuggestions}
            onChange={(option) => handleUserChange(option)}
          />
        )}
        {isFormik && (
          <ErrorMessage
            name={name}
            component={FormError}
            className={classes.error}
          />
        )}
      </div>
    </>
  );
};

export default UserSelectField;
